<template>
  <section class="wrap_pop">
        <div class="popbox_wrap">
            <div class="popbox_cont">
                <div class="box_msg type_naver">
                    <p>네이버 인증서 유의사항</p>
                </div>
                <div class="box_info">
                    <ul class="info_step">
                        <li><span>step1.</span> 네이버 App 설치 및 로그인</li>
                        <li><span>step2.</span> 네이버 인증서 발급</li>
                        <li><span>step3.</span> 네이버 App,Push알림 수신설정</li>
                    </ul>
                </div>
                <div class="info_wrap">
                    <div class="tit">설정확인 방법</div>
                    <div class="cont">
                        <ul class="info_next">
                            <li>네이버 App설정 <span class="gt">&gt;</span> 내정보 보안기능 <span class="gt">&gt;</span></li>
                            <li>네이버 고지서 인증서 <span class="gt">&gt;</span> 네이버 인증서</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="popbox_btn">
                <!-- <div><button type="button" class="btn color2">취소</button></div> -->
                <div><button type="button" class="btn color1" @click="$emit('close')">확인</button></div>
            </div>
        </div>
    </section>
</template>